export const PDF_CONFIGURATION_PATH = '/company/pdf-configuration';

export const STORE_KEYS = {
  CONTACT_TEXT: 'contactText',
  SHOW_AGENT_INFO: 'showAgentInfo',
  ALWAYS_ASK_AGENT_INFO: 'alwaysAskAgentInfo',
  ADDRESS_FIELD: 'addressField',
  ADDRESS_FIELD_DOWNLOAD: 'addressFieldDownload',
  SHOW_PRICE: 'showPrice',
  COMPLETE_DEV_PHOTOS: 'completeDevPhotos',
  EXPORT_IN_ENGLISH: 'exportInEnglish',
};

export const BACK_KEYS = {
  contactText: 'pdf_footer_text',
  showAgentInfo: 'pdf_show_agent_info',
  alwaysAskAgentInfo: 'pdf_always_ask_agent_info',
  addressField: 'pdf_address_field',
  addressFieldDownload: 'pdf_address_field_download',
  showPrice: 'pdf_show_price',
  completeDevPhotos: 'pdf_complete_dev_photos',
  exportInEnglish: 'export_pdf_in_english',
};

// Fields the sender reads from AuthSlice.companyConfig.
export const COMPANY_CONFIG_KEYS = [
  STORE_KEYS.ALWAYS_ASK_AGENT_INFO,
  STORE_KEYS.EXPORT_IN_ENGLISH,
];

// Success toast shown after saving each field.
export const SUCCESS_TOAST_KEYS = {
  contactText: 'ContactInformationUpdated',
  showAgentInfo: 'AgentInformationUpdated',
  alwaysAskAgentInfo: 'AgentInformationUpdated',
  addressField: 'PropertyAddressUpdated',
  addressFieldDownload: 'PropertyAddressUpdated',
  showPrice: 'PriceValuesUpdated',
  completeDevPhotos: 'DevelopmentImagesUpdated',
  exportInEnglish: 'LanguageSelectionUpdated',
};

// Backend codes of Company.PDF_ADDRESS_FIELD_CHOICES.
export const ADDRESS_FIELD = {
  DEFAULT: 'default',
  REAL_ADDRESS: 'real_address',
  FAKE_ADDRESS: 'fake_address',
  NEIGHBOURHOOD: 'neighbourhood',
  NEIGHBOURHOOD_NODE: 'neighbourhood_node',
  STREET: 'street',
  STREET_NUMBER: 'street_number',
};

// `pdf_show_price` stores the label of Company.PDF_SHOW_PRICE_CONFIG, not a
// code: the backend rejects anything else.
export const SHOW_PRICE = {
  SHOW: 'Show price',
  DONT_SHOW: 'Do not show prices',
  SHOW_WITH_WEB_PRICE: 'Show with web price',
};

// Figma options, in order. "Publishing address" is `default` (falls back to
// the real address) and "Neighborhood" is `neighbourhood_node` (shown from the
// neighborhood node). A company that still has the legacy `fake_address` or
// `neighbourhood` sees it in their place, see buildAddressOptions.
export const ADDRESS_OPTION_TRANSLATION_KEYS = [
  { value: ADDRESS_FIELD.DEFAULT, key: 'PublishingAddress' },
  { value: ADDRESS_FIELD.NEIGHBOURHOOD_NODE, key: 'Neighborhood' },
  { value: ADDRESS_FIELD.STREET, key: 'Street' },
  { value: ADDRESS_FIELD.STREET_NUMBER, key: 'StreetAndNumber' },
  { value: ADDRESS_FIELD.REAL_ADDRESS, key: 'RealAddress' },
];

export const AGENT_INFO_OPTION_TRANSLATION_KEYS = [
  { value: true, key: 'ShowAgentInformation' },
  { value: false, key: 'DoNotShowAgentInformation' },
];

export const PRICE_OPTION_TRANSLATION_KEYS = [
  { value: SHOW_PRICE.SHOW, key: 'ShowPrice' },
  { value: SHOW_PRICE.DONT_SHOW, key: 'DoNotShowPrices' },
  { value: SHOW_PRICE.SHOW_WITH_WEB_PRICE, key: 'ShowPriceOnlyIfPublicOnWeb' },
];

export const DEV_PHOTOS_OPTION_TRANSLATION_KEYS = [
  { value: true, key: 'UseUnitAndDevelopmentImages' },
  { value: false, key: 'UseUnitImagesOnly' },
];

// Generic data of the address preview (Figma 243:29624), by language prefix.
// Design defines the street; number and publishing address are proposals
// pending product confirmation. The location line comes from the user's
// branch (pdf_address_preview_location).
export const ADDRESS_PREVIEW_EXAMPLES = {
  es: {
    street: 'Calle Principal',
    streetNumber: 'Calle Principal 1234',
    realAddress: 'Calle Principal 1234 2do A',
    publishingAddress: 'Calle Principal al 1200',
  },
  pt: {
    street: 'Rua Principal',
    streetNumber: 'Rua Principal 1234',
    realAddress: 'Rua Principal 1234 2º A',
    publishingAddress: 'Rua Principal 1200',
  },
  en: {
    street: 'Main Street',
    streetNumber: 'Main Street 1234',
    realAddress: 'Main Street 1234 2nd A',
    publishingAddress: 'Main Street 1200 block',
  },
};

export const DEFAULT_PREVIEW_LANGUAGE = 'en';

export const ADDRESS_PREVIEW_REFERENCE_CODE = 'REF1234';
